<template>
  <!-- <div v-if="$route.name == 'mobileMain'" class="video">
     <video autoplay muted loop>
       <source src="@/assets/img/main_video.mp4" type="video/webm" />
       <source src="@/assets/img/main_video.mp4" type="video/mp4" />
     </video>
  </div> -->
  <main-header />
  <router-view :key="$route.fullPath"></router-view>
  <slot-list v-if="isSlotOpen" :groupCode="groupCode" :codeName="codeName" @isSlot="isSlotOpen = false"></slot-list>
  <loading></loading>
</template>

<script>
import '@/styles_mobile/reset.css'

import MainHeader from './Header'
import SlotList from '@/components/game/SlotList'
import Loading from '@/components/common/Loading.vue'

export default {
  name: 'MobileDefaultLayout',
  components: {
    SlotList,
    MainHeader,
    Loading
  },
  mounted () {
    this.emitter.on('isSlot', (data) => {
      if (data) {
        const groupCode = data.groupCode
        const codeName = data.codeName
        this.getSlotOpen(groupCode, codeName)
      } else {
        this.isSlotOpen = false
      }
    })
  },
  data () {
    return {
      isSlotOpen: false,
      groupCode: '',
      codeName: ''
    }
  },
  methods: {
    getSlotOpen (groupCode, codeName) {
      if (this.userData) {
        this.groupCode = groupCode
        this.codeName = codeName
        this.isSlotOpen = true
      } else {
        // this.onCheck('front.error.afterSignin')
        alert(this.$t('front.error.afterSignin'))
      }
    }
  }
}
</script>

<style>
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-active {
  transition: opacity 0.1s ease-in;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(185px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-leave-to {
  transform: translateY(0px);
  opacity: 0;
}
.video {width: 100%;max-height: 520px;overflow: hidden;position: relative;}
.video video {height: 100%;width: 100%;object-fit: cover;vertical-align: bottom;}
</style>
